import { render, staticRenderFns } from "./ListTransferStoreForms.vue?vue&type=template&id=f52c0d6e&scoped=true&"
import script from "./ListTransferStoreForms.vue?vue&type=script&lang=js&"
export * from "./ListTransferStoreForms.vue?vue&type=script&lang=js&"
import style0 from "./ListTransferStoreForms.vue?vue&type=style&index=0&id=f52c0d6e&prod&scoped=true&lang=css&"
import style1 from "./ListTransferStoreForms.vue?vue&type=style&index=1&id=f52c0d6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52c0d6e",
  null
  
)

export default component.exports